const domainModel = require('domain-model');
const _ = require('lodash');

const calculateQuantityOnIncrement = (
  value,
  increment,
  selectedOrderUnit,
  minWeightIncrement,
) => {
  const incrementValue = _.toNumber(increment);

  let quantityOnOrder = value + incrementValue;

  if (selectedOrderUnit === domainModel.article.orderUnits.weight) {
    quantityOnOrder =
      value + (incrementValue / minWeightIncrement) * minWeightIncrement;
  }
  if (quantityOnOrder < 0 || quantityOnOrder < 0) quantityOnOrder = 0;

  return _.round(quantityOnOrder, 2);
};

const calculateFromSetQuantity = (
  newInputValue,
  selectedOrderUnit,
  colliSize,
  minWeightIncrement,
) => {
  let incomingValue = _.toNumber(newInputValue);

  if (selectedOrderUnit !== domainModel.article.orderUnits.weight) {
    incomingValue = _.round(incomingValue);
  }

  let quantityOnOrder = incomingValue;

  if (selectedOrderUnit === domainModel.article.orderUnits.package) {
    quantityOnOrder = incomingValue * colliSize;
  }

  if (selectedOrderUnit === domainModel.article.orderUnits.weight) {
    const rest = incomingValue % minWeightIncrement;
    quantityOnOrder = incomingValue - rest;
    const shouldRoundUp = rest / minWeightIncrement > 0.5;
    if (shouldRoundUp) {
      quantityOnOrder += minWeightIncrement;
    }
  }
  if (incomingValue < 0) {
    quantityOnOrder = 0;
  }

  return _.round(quantityOnOrder, 2);
};
const getQuantityFromCollis = (value, colliSize) => {
  const roundedValue = value > colliSize / 2 ? _.round(value / colliSize) : 1;
  return roundedValue * colliSize;
};
module.exports = {
  calculateQuantityOnIncrement,
  calculateFromSetQuantity,
  getQuantityFromCollis,
};
